import useSWR from 'swr';
import api from 'utils/api';

const PRICING_URL = '/common/offer-pricing';

const fetchPricing = async () => {
  const pricing = await api.get(PRICING_URL);
  if (pricing?.currency !== 'USD'
    || !Number.isInteger(pricing.localRadiusThresholdMiles) || pricing.localRadiusThresholdMiles <= 0
    || !['localPrice', 'extendedPrice', 'globalPrice'].every((key) => (
      typeof pricing[key] === 'number' && Number.isFinite(pricing[key]) && pricing[key] > 0
    ))) {
    throw new Error('Claim pricing is unavailable.');
  }
  return pricing;
};

export function useOfferPricing() {
  const { data, error, isLoading, isValidating, mutate } = useSWR(PRICING_URL, fetchPricing, {
    revalidateOnMount: true,
    revalidateOnFocus: true,
    focusThrottleInterval: 0,
    shouldRetryOnError: false,
  });
  return { pricing: data, error, loading: isLoading || isValidating, retry: mutate };
}

export function claimPriceForTargeting(pricing, regionType, localTargets = []) {
  if (!pricing) return null;
  switch (String(regionType).toLowerCase()) {
    case 'global': return pricing.globalPrice;
    case 'state':
    case 'us':
    case 'zip': return pricing.extendedPrice;
    case 'local': {
      if (!localTargets.length || localTargets.some((target) => (
        !Number.isFinite(Number(target.radius)) || Number(target.radius) <= 0
      ))) return null;
      return localTargets.length > 1 || Number(localTargets[0].radius) > pricing.localRadiusThresholdMiles
        ? pricing.extendedPrice : pricing.localPrice;
    }
    default: return null;
  }
}
